<template>
  <ModalDialog v-if="status < 0" :show="true" :can-close="false">
    <div class="sf-modal-body">
      <template v-if="errorMessage == 'loggedOut' || errorMessage == 'userIdConflict'">
        <template v-if="errorMessage == 'userIdConflict'">
          <h2 class="tw-text-danger tw-text-center">
            You have logged in as a different user
          </h2>
          <p>
            You have been logged in as a different user while completing the test.
            Please login again to save your results.
          </p>
        </template>
        <template v-else>
          <h2 class="tw-text-danger tw-text-center">Logged Out</h2>
          <p>
            You have been logged out while completing the test.
            Please login again to save your results.
          </p>
        </template>
        <div class="tw-text-center">
          <div class="tw-mx-auto tw-text-left">
            <LoginForm screen="login" @loggedin="onSaveAgain" />
          </div>
        </div>
        <div>
          <a href="" @click.prevent="onShowResults"> 
            or show test results without saving
          </a>
        </div>
      </template>
      <template v-else-if="errorMessage == 'testDeadlineExpired'">
        <h2 class="tw-text-danger tw-text-center">Deadline Expired</h2>
        <div>
          While you were completing this test the deadline to complete it has expired.
        </div>
      </template>
      <template v-else-if="status == -1">
        <h2 class="tw-text-danger tw-text-center">Error Saving</h2>
        <p>There was an error saving your results</p>
        <p>
          please check your connection and try saving again.
        </p>
        <p class="tw-mt-4">
          <button @click.prevent="onSaveAgain" class="sf-btn-primary">
            Save Again
          </button>
        </p>
        <p>
          <a href="" @click.prevent="onShowResults">
            or show test results without saving
          </a>
        </p>
      </template>
      <template v-else>
        <h2 class="tw-text-center tw-text-danger">Error Saving</h2>
        <p>There was an error saving your results</p>
        <p>
          Try to save your results again, if the error continues please report it
          to your teacher.
        </p>
        <p>
          Remember to tell them the day and time when this happened.
        </p>
        <p class="tw-mt-4">
          <button @click.prevent="onSaveAgain" class="sf-btn-primary">
            Save Again
          </button>
        </p>
        <p>
          <a href="" @click.prevent="onShowResults">
            or show test results without saving
          </a>
        </p>
      </template>
    </div>
  </ModalDialog>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { 
  spellingSaveErrorMessage, 
  spellingActivitySaveStatus, 
  spellingGameAttemptSave, 
  setSpellingGameSaveStatus
} from '@/state/spellingGameState';
import LoginForm from '../login/LoginForm.vue';
import ModalDialog from '../ui/ModalDialog.vue';
import { mathsGameSaveStatus, mathsSaveErrorMessage, saveLastMathAnswerAgain, setMathsGameSaveStatus } 
  from '@/state/mathsGameState';
import { SfMathsAnswerResult } from '@/types/mathsTypes.js';

export default defineComponent({
  components: { LoginForm, ModalDialog },
  props: {
    subject: { type: String as PropType<'spelling' | 'maths'>, required: true },
  },
  computed: {
    errorMessage() {
      if(this.subject == 'maths') {
        return mathsSaveErrorMessage.value;
      }
      return spellingSaveErrorMessage.value;
    },
    status() {
      if(this.subject == 'maths') {
        return mathsGameSaveStatus.value;
      }
      return spellingActivitySaveStatus.value;
    }
  },
  methods: {
    async onSaveAgain() {
      if(this.subject == 'maths') {
        const data = await saveLastMathAnswerAgain();
        if(data) {
          this.$emit('mathsaved', data as SfMathsAnswerResult);
        }
      } else if(this.subject == 'spelling') {
        spellingGameAttemptSave();
      }
    },
    onShowResults() {
      if(this.subject == 'maths') {
        this.$emit('showmathresults');
        setMathsGameSaveStatus(3);
      } else {
        setSpellingGameSaveStatus(3);
      }
    },  
  },
}) 
</script>